var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetirementSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "retirementSimple-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(60 494.063)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retirementSimple",
    transform: "translate(-60 -494.063)",
    clipPath: "url(#retirementSimple-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8,16.943a1.023,1.023,0,0,0-.686-.437c-1.435,0-13.786-.5-13.786-14.847a.811.811,0,1,0-1.622,0C14.7,16.007,2.349,16.506.977,16.506a.708.708,0,0,0-.5.187c-.125.062-.187.187-.25.249a.925.925,0,0,0,0,.811.866.866,0,0,0,.749.437h.062c1.435,0,13.724.5,13.724,14.847a.811.811,0,1,0,1.622,0c0-14.285,12.289-14.847,13.724-14.847a.951.951,0,0,0,.749-.437A.767.767,0,0,0,30.8,16.943ZM15.512,26.924A14.239,14.239,0,0,0,5.78,17.317,14.239,14.239,0,0,0,15.512,7.71a14.239,14.239,0,0,0,9.732,9.607A14.239,14.239,0,0,0,15.512,26.924Z",
    transform: "translate(93.144 494.215)",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementSimple);
export default __webpack_public_path__ + "static/media/retirementSimple.d80648a6d1b1584dcd4a9aab1785db46.svg";
export { ForwardRef as ReactComponent };